import React, { Component } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import { getCurrencies } from "../../../../services/setup/finance/financeSetupService";
import withGlobalData from "../../common/withGlobalData";
class SearchCurrency extends Component {
  state = { reload: this.props.globalData.reload, currencies: [] };

  componentDidMount() {
    this.getCurrencies();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getCurrencies();
      this.setState({ reload: globalData.reload });
    }
  }

  async getCurrencies() {
    const response = await getCurrencies();
    const { data } = response.data;
    this.setState({ open: false, currencies: data.currencies });
  }

  render() {
    const { currencies } = this.state;
    const { onSelectCurrency } = this.props;
    return (
      <CustomDataTableSearch
        data={currencies}
        onRefreshData={() => {
          this.getCurrencies();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectCurrency(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectCurrency(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Currency Code",
            field: "currencyCode",
            body: null,
            sortable: true,
          },
          {
            header: "Currency Symbol",
            field: "currencySymbol",
            body: null,
            sortable: true,
          },
          {
            header: "Currency Name",
            field: "currencyName",
            body: null,
            sortable: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchCurrency);
